export default "__VITE_ASSET__Bu9tq5MG__"